<interacta-live-status [message]="announcement()" />

<ng-template #panelContent>
    @if (isVisible()) {
        <interacta-toast-notification-panel
            animate.enter="animate-slide-in"
            class="w-full slide-from-right-xl motion-reduce:animate-none"
            [expanded]="expanded()"
            [groups]="groups()"
            (animate.leave)="leave($event)"
            (closePanel)="close()"
            (expandPanel)="expand()"
        />
    }
</ng-template>
